import { render, staticRenderFns } from "./newProjectReports.vue?vue&type=template&id=5e903ee6&scoped=true"
import script from "./newProjectReports.vue?vue&type=script&lang=ts"
export * from "./newProjectReports.vue?vue&type=script&lang=ts"
import style0 from "./newProjectReports.vue?vue&type=style&index=0&id=5e903ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e903ee6",
  null
  
)

export default component.exports